import React from 'react';
import { motion } from 'framer-motion';
const locations = [{
  name: 'Costa Rica',
  region: 'Pacific Coast',
  tagline: 'Surf. Jungle. Pacific light.',
  img: 'https://images.unsplash.com/photo-1518602164578-cd0074062767?w=900&q=80&auto=format&fit=crop'
}, {
  name: 'Mexico',
  region: 'Oaxaca · Tulum',
  tagline: 'Color. Craft. Coastline.',
  img: 'https://images.unsplash.com/photo-1518638150340-f706e86654de?w=900&q=80&auto=format&fit=crop'
}, {
  name: 'Portugal',
  region: 'Comporta · Algarve',
  tagline: 'Atlantic light. Slow days.',
  img: 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=900&q=80&auto=format&fit=crop'
}];
export function Locations() {
  return <section id="locations" className="bg-paper py-24 md:py-32 px-6 md:px-10" data-id="element-68">
      <div className="max-w-6xl mx-auto" data-id="element-69">
        <div className="mb-14 md:mb-20 max-w-2xl" data-id="element-70">
          <p className="eyebrow mb-5" data-id="element-71">Launching 2027</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="font-serif-display text-3xl md:text-5xl text-ink leading-[1.1]" data-id="element-72">
            Where you'll <span className="italic" data-id="element-73">land.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6" data-id="element-74">
          {locations.map((l, i) => <motion.div key={l.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          delay: i * 0.12
        }} className="group relative" data-id="element-75">
              <div className="aspect-[3/4] overflow-hidden" data-id="element-76">
                <img src={l.img} alt={l.name} className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105" data-id="element-77" />
              </div>
              <div className="mt-5 flex items-baseline justify-between" data-id="element-78">
                <div data-id="element-79">
                  <p className="eyebrow !text-muted mb-2" data-id="element-80">
                    0{i + 1} · {l.region}
                  </p>
                  <h3 className="font-serif-display text-3xl md:text-4xl text-ink" data-id="element-81">
                    {l.name}
                  </h3>
                  <p className="font-serif-display italic text-ink/55 text-base mt-1" data-id="element-82">
                    {l.tagline}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-14 text-center font-serif-display italic text-ink/40 text-base" data-id="element-83">
          More destinations coming soon.
        </p>
      </div>
    </section>;
}